// extracted by mini-css-extract-plugin
export var gif = "_jg-0";